export const mindboxId = 'algoritmika.Website'
export const mindboxDomains = ['algoritmika.org']
export const mindboxFormPaths = ['/ru/math', '/ru/coding', '/ru', '/']
